import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { KsefApiService } from '../../services/ksef-api.service';
import { KsefInvoice } from '../../models/ksef-invoice.model';
import { Roles } from 'src/app/shared/models/auth/role.model';

@Component({
  selector: 'app-ksef-cancelled-list',
  templateUrl: './ksef-cancelled-list.component.html',
})
export class KsefCancelledListComponent implements OnInit {
  invoices$!: Observable<KsefInvoice[]>;
  Roles = Roles;

  constructor(private ksefApi: KsefApiService) {}

  ngOnInit(): void {
    this.invoices$ = this.ksefApi.getCancelledInvoices();
  }

  statusClass(status: string): string {
    return (status || '').toLowerCase();
  }
}
